import { render, staticRenderFns } from "./ProductInfoSections.vue?vue&type=template&id=143a4e82"
import script from "./ProductInfoSections.vue?vue&type=script&lang=js"
export * from "./ProductInfoSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fproduct-info-sections%2FProductInfoSections.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports